import React, { useEffect, useState } from 'react'
import { getGoodTypesAllAPI } from '../../../api/products/goodTypeAPI'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getGoodsAllAPI } from '../../../api/products/goodAPI'
import MySpiner from '../../UI/spiner/MySpiner'

const GoodSelectMain = ({ goodTypeId, required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [goods, setGoods] = useState([])

	const [loading, setLoading] = useState(false)

	useEffect(() => {
		getGoodTypes()
	}, [goodTypeId])

	useEffect(() => {
		valid()
	}, [required, value])

	const getGoodTypes = () => {
		setValueForm(null)
		setValue('')
		if (goodTypeId) {
			setLoading(true)
			getGoodsAllAPI({ goodTypeId }).then(data => {
				setGoods(data)
				setLoading(false)
			}).catch(e => {
				// setError(responseError(e))
				setLoading(false)
				console.error(responseError(e))
			})
		}
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
	<>
		{
			loading ?
				<MySpiner />
			:
				<MySelect
					value={value}
					label="Товар"
					labelId="select__good-label"
					id='select__good'
					onChange = {e => {
						setValueForm(e)
						setValue(e)
						// setEvent({...event, categoryId: e})
					}}
					nameField='Товар'
					// sx={{width: '200px'}}
					options={
						goods && goods.length > 0 ? 
							goods.map(good => {
								return {id: good.id, name: good.name}
							})
						: []	
					}
					// options={[]}
				/>
		}
	</>
  )
}

export default GoodSelectMain